export default "__VITE_ASSET__CfZ1IKeE__"